module.exports = __webpack_public_path__ + "static/media/text_icon_2.235d6960.svg";